export const isResidentChoice = isResident =>
  isResident === null || isResident === undefined ? '' : String(Number(isResident))
